import { connect } from 'react-redux'
import AlertComponent from '../components'

const mapStateToProps = (state) => ({
  feedback: state.actionFeedback.actionMessage,
})

const FeedbackAction = connect(mapStateToProps, {})(AlertComponent)

export default FeedbackAction
